<template>
  <b-overlay :show="loading"
             spinner-variant="primary"
             spinner-type="grow">
    <div class="cont-steps container">

      <header-component class="align-self-start"></header-component>


      <template v-if="!loading">

        <transition name="zoom-fade" mode="out-in">
          <router-view
              class="align-self-center"
              :options="options"
              :steps="steps"
              :current="current"
              @changeSteps="steps = $event"
              @setCurrent="current = $event"
              @nextStep="nextStep(...arguments)"
          />
        </transition>

        <steps-line-component v-if="current <= steps" class="py-4 align-self-end" :steps="steps" :current="current"
                              :options="options"
                              @changeCurrent="changeCurrent(...arguments)"></steps-line-component>
        <template v-else>
          <div class="my-4 pt-2 align-self-end"></div>
        </template>

      </template>

    </div>
  </b-overlay>
</template>

<script>
import StepsLineComponent from "@/components/StepsLineComponent";
import HeaderComponent from "@/components/HeaderComponent";

export default {
  name: 'Configuratore',
  metaInfo: {
    title: 'Configuratore - SGR Servizi Gas e Luce',
    meta: [
      {
        name: 'description',
        content: 'Scopri i vantaggi di passare a SGR Luce e Gas. Personalizza con noi la tua energia!'
      }
    ]
  },
  data() {
    return {
      endStep: 7,
      steps: 3,
      current: 0,
      loading: false,
      result: null,
      webPath: process.env.VUE_APP_WEB_PATH,
      options: {
        step: 0,
        comune: null,
        propertyType: null,
        energyType: null,
        marketType: null,
        companyType: null,
        useType: null,
        isClient: null,
      },
      showResults: false,
    }
  },
  created() {
    let comune = this.$route.query.comune;
    if (typeof comune !== 'undefined' && comune != null && comune.length > 0) this.options.comune = comune;
  },
  methods: {
    changeCurrent(step) {
      this.options.step = step;
      this.current = step;
      this.$router.push({name: 'step-' + step})
    },

    nextStep(nextStep, realNextStep, localOptions) {
      this.options = localOptions;
      this.options.step = nextStep;
      this.current = nextStep;
      if (realNextStep >= this.endStep) this.$router.push({name: 'results'})
      else this.$router.push({name: 'step-' + realNextStep, query: {comune: this.options.comune}})
    },

  },
  components: {HeaderComponent, StepsLineComponent},
  beforeRouteUpdate(to, from, next) {
    let comune = to.query.comune;
    if (typeof comune !== 'undefined' && comune != null && comune.length > 0) this.options.comune = comune;
    next()
  }
}
</script>

<style lang="scss">
.cont-steps {
  display: flex;
  flex-wrap: wrap;
  height: calc(var(--vh, 1vh) * 100);

  & > header,
  & > div {
    width: 100%;
  }
}

.config-button-element {
  cursor: pointer;
  text-align: center;
  padding: 64px 16px 32px;
  width: 100%;
  height: 100%;
  min-height: 322px;
  border-radius: 8px;

  background: #ECF1F4 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 2px #00000029;
  opacity: 1;
  margin: 14px;

  i {
    font-size: 120px;
    margin-bottom: 30px;
    display: block;
    margin-left: 8px;
  }

  & + .config-button-element {
  }
}

@media (max-width: 767.98px) {
  .h3-semibold-black {
    font-size: 24px;
    line-height: 30px;
  }
  .config-button-element {
    padding: 32px 16px;
    min-height: auto;
    margin: 0;

    i {
      font-size: 100px;
      margin-bottom: 8px;
    }
  }
}

@media (max-height: 568px) {
  .h3-semibold-black {
    font-size: 20px;
    line-height: 28px;
  }
  .h2-semibold-azure {
    font-size: 24px;
  }
  .p-medium-gray-600 {
    font-size: 14px;
    line-height: 22px;
  }
  .config-button-element {
    padding: 22px 16px;
    min-height: auto;
    margin: 0;
  }
}
</style>
